import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostOdontoBookingConfirm,
	PostOdontoBookingConfirmParams,
	PostOdontoBookingConfirmModel,
} from 'domain/usecases';

export class RemotePostOdontoBookingConfirm implements PostOdontoBookingConfirm {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostOdontoBookingConfirmModel>,
	) {}

	async post(params: PostOdontoBookingConfirmParams): Promise<PostOdontoBookingConfirmModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
